import React from 'react';
import { motion } from 'framer-motion';
import { Star, Quote } from 'lucide-react';
const testimonials = [{
  name: 'Matías',
  city: 'Buenos Aires',
  age: 28,
  text: 'Antes los martes me la pasaba tomando mate mirando la calle. Ahora tengo turnos fijos en la semana y el sábado corto a las 18hs. Un cambio total.'
}, {
  name: 'Franco',
  city: 'Córdoba',
  age: 32,
  text: 'El protocolo anticancelaciones me salvó la vida. Ya no pierdo plata por gente que me avisa 10 minutos antes. El plan se paga solo.'
}, {
  name: 'Nicolás',
  city: 'Rosario',
  age: 25,
  text: 'Pensé que era humo, pero apliqué lo de mover clientes del sábado al miércoles y funcionó. Mi espalda agradece no estar 12 horas parado el finde.'
}, {
  name: 'Santiago',
  city: 'Mendoza',
  age: 35,
  text: 'Aumenté mi ingreso sin subir el precio base, solo ordenando la agenda y ofreciendo servicios complementarios como dice la guía. Excelente material.'
}, {
  name: 'Braian',
  city: 'Tucumán',
  age: 24,
  text: 'La guía anti-finde es oro puro. Termino la semana con energía para salir con mi familia en vez de tirarme a dormir todo el domingo.'
}];
export function TestimonialsSection() {
  return <section className="py-20 px-4 sm:px-6 lg:px-8 max-w-6xl mx-auto" data-id="element-256">
      <div className="text-center mb-12" data-id="element-257">
        <h2 className="text-3xl md:text-4xl font-heading font-bold text-white uppercase" data-id="element-258">
          Barberos que ya ordenaron su semana
        </h2>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6" data-id="element-259">
        {testimonials.map((t, i) => <motion.div key={i} initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        delay: i * 0.1
      }} className={`bg-zinc-900 border border-zinc-800 p-6 rounded-2xl relative ${i === 4 ? 'md:col-span-2 lg:col-span-1' : ''}`} data-id="element-260">
            <Quote className="absolute top-4 right-4 w-8 h-8 text-zinc-800" data-id="element-261" />
            <div className="flex gap-1 mb-4" data-id="element-262">
              {[...Array(5)].map((_, j) => <Star key={j} className="w-4 h-4 fill-amber-500 text-amber-500" data-id="element-263" />)}
            </div>
            <p className="text-zinc-300 text-lg mb-6 relative z-10 italic" data-id="element-264">
              "{t.text}"
            </p>
            <div className="flex items-center gap-3 border-t border-zinc-800 pt-4" data-id="element-265">
              <div className="w-10 h-10 bg-zinc-800 rounded-full flex items-center justify-center text-amber-500 font-bold font-heading" data-id="element-266">
                {t.name.charAt(0)}
              </div>
              <div data-id="element-267">
                <p className="text-white font-bold" data-id="element-268">{t.name}</p>
                <p className="text-sm text-zinc-500" data-id="element-269">
                  {t.city} • {t.age} años
                </p>
              </div>
            </div>
          </motion.div>)}
      </div>
    </section>;
}